module.exports = __webpack_public_path__ + "static/media/Tab_Results_Inactive.be8c617f.png";